/**
 * @fileoverview gRPC-Web generated client stub for reportpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: reportpb/settlementfunding.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_api_annotations_pb = require('../google/api/annotations_pb.js')

var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.reportpb = require('./settlementfunding_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.SettlementFundingServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.SettlementFundingServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListSettlementFundingRequest,
 *   !proto.reportpb.ListSettlementFundingResponse>}
 */
const methodDescriptor_SettlementFundingService_ListSettlementFunding = new grpc.web.MethodDescriptor(
  '/reportpb.SettlementFundingService/ListSettlementFunding',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListSettlementFundingRequest,
  proto.reportpb.ListSettlementFundingResponse,
  /**
   * @param {!proto.reportpb.ListSettlementFundingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListSettlementFundingResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListSettlementFundingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.ListSettlementFundingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListSettlementFundingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.SettlementFundingServiceClient.prototype.listSettlementFunding =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.SettlementFundingService/ListSettlementFunding',
      request,
      metadata || {},
      methodDescriptor_SettlementFundingService_ListSettlementFunding,
      callback);
};


/**
 * @param {!proto.reportpb.ListSettlementFundingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListSettlementFundingResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.SettlementFundingServicePromiseClient.prototype.listSettlementFunding =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.SettlementFundingService/ListSettlementFunding',
      request,
      metadata || {},
      methodDescriptor_SettlementFundingService_ListSettlementFunding);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.SettlementFunding,
 *   !proto.reportpb.UpdateSettlementFundingResponse>}
 */
const methodDescriptor_SettlementFundingService_UpdateSettlementFunding = new grpc.web.MethodDescriptor(
  '/reportpb.SettlementFundingService/UpdateSettlementFunding',
  grpc.web.MethodType.UNARY,
  proto.reportpb.SettlementFunding,
  proto.reportpb.UpdateSettlementFundingResponse,
  /**
   * @param {!proto.reportpb.SettlementFunding} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.UpdateSettlementFundingResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.SettlementFunding} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.UpdateSettlementFundingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.UpdateSettlementFundingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.SettlementFundingServiceClient.prototype.updateSettlementFunding =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.SettlementFundingService/UpdateSettlementFunding',
      request,
      metadata || {},
      methodDescriptor_SettlementFundingService_UpdateSettlementFunding,
      callback);
};


/**
 * @param {!proto.reportpb.SettlementFunding} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.UpdateSettlementFundingResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.SettlementFundingServicePromiseClient.prototype.updateSettlementFunding =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.SettlementFundingService/UpdateSettlementFunding',
      request,
      metadata || {},
      methodDescriptor_SettlementFundingService_UpdateSettlementFunding);
};


module.exports = proto.reportpb;

